import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63316fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<br data-v-63316fb8><br data-v-63316fb8><div class=\"menuStationMappingTableDiv0\" data-v-63316fb8><table id=\"tblMenuStationMappingHeader\" data-v-63316fb8><thead data-v-63316fb8><tr data-v-63316fb8><th style=\"width:10%;\" data-v-63316fb8>Menu</th><th style=\"width:15%;\" data-v-63316fb8>Company</th><th style=\"width:5%;\" data-v-63316fb8>Edit</th><th style=\"width:5%;\" data-v-63316fb8>Delete</th></tr></thead></table></div>", 3)
const _hoisted_6 = {
  key: 1,
  style: {"height":"calc(97% - 250px)"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "No data", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  id: "divMenuStationMappingTable",
  class: "menuStationMappingTableDiv0",
  style: {"overflow":"auto","height":"calc(97% - 250px)","margin-top":"0%"}
}
const _hoisted_10 = {
  id: "tblMenuStationMappingBody",
  class: "w-100"
}
const _hoisted_11 = { style: {"width":"10%","text-align":"left"} }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { style: {"width":"15%","text-align":"left"} }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { style: {"width":"5%"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { style: {"width":"5%"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  class: "modal fade",
  id: "menuStationMappingModal",
  tabindex: "-1",
  "aria-labelledby": "menuStationMappingModalLabel",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  class: "modal-dialog modal-lg modal-dialog-scrollable",
  role: "document",
  style: {"height":"430px","width":"500px"}
}
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = { class: "modal-header" }
const _hoisted_23 = {
  class: "modal-title",
  id: "menuStationMappingModalLabel"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, "x", -1 /* HOISTED */))
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = { class: "form-row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Main Title：", -1 /* HOISTED */))
const _hoisted_28 = { class: "select-wrapper" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "menu" }, "Main Menu：", -1 /* HOISTED */))
const _hoisted_32 = { class: "select-wrapper" }
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  class: "adjusting-position fs-6",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_35 = { class: "form-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "station" }, "Station Code：", -1 /* HOISTED */))
const _hoisted_37 = { class: "select-wrapper" }
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  class: "adjusting-position fs-6",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_40 = { class: "modal-footer" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  id: "cancel"
}, " Cancel ", -1 /* HOISTED */))
const _hoisted_42 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_43 = { class: "modal-dialog" }
const _hoisted_44 = {
  class: "modal-content",
  style: {"height":"40%"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "deleteModalLabel"
  }, "Delete Menu-Station Mapping"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-body",
  style: {"flex":"0 0 auto"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, "Are you sure to delete this Menu-Station Mapping?")
], -1 /* HOISTED */))
const _hoisted_47 = { class: "modal-footer" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  id: "deleteCancel"
}, " Cancel ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Alert"], {
      "alert-message": $setup.alertMessage,
      "alert-state": $setup.alertState
    }, null, 8 /* PROPS */, ["alert-message", "alert-state"]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.menuTitle }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_2,
    _createElementVNode("button", {
      class: "btn btn-primary add text-center",
      "data-bs-toggle": "modal",
      "data-bs-target": "#menuStationMappingModal",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickAddButton()))
    }, " Add Menu-Station Mapping "),
    _hoisted_3,
    ($setup.menuStationMappingList.length == 0 && $setup.isNoData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuStationMappingList, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(info.mainmenucode + ' : ' + info.mainmenuname), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(info.stationcode + ' : ' + info.companyname), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("button", {
                      class: "btn btn-primary button-design-edit",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#menuStationMappingModal",
                      onClick: ($event: any) => ($setup.onClickEditButton(info.id))
                    }, " Edit ", 8 /* PROPS */, _hoisted_16)
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "btn btn-primary button-design-edit",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#deleteModal",
                      onClick: ($event: any) => ($setup.getDeleteId(info.id))
                    }, " Delete ", 8 /* PROPS */, _hoisted_18)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h5", _hoisted_23, _toDisplayString($setup.modalTitle), 1 /* TEXT */),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select search-form-select",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedMainTitle) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.getMenuByTitle($event)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mainTitleList[0], (tilteObj, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "adjusting-option",
                      key: index,
                      value: tilteObj.mainTitleCode
                    }, _toDisplayString(tilteObj.mainTitleCode + ' : ' + tilteObj.mainTitleName), 9 /* TEXT, PROPS */, _hoisted_29))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelSelect, $setup.selectedMainTitle]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select search-form-select",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedMenu) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList[0], (menuObj, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "adjusting-option",
                      key: index,
                      value: menuObj.mainMenuCode
                    }, _toDisplayString(menuObj.mainMenuCode + ' : ' + menuObj.mainMenuName), 9 /* TEXT, PROPS */, _hoisted_33))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.selectedMenu]
                ])
              ]),
              _createElementVNode("span", _hoisted_34, _toDisplayString($setup.selectedMenuerror), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select search-form-select",
                  style: {},
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedStation) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stationList[0], (station, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "adjusting-option",
                      key: index,
                      value: station.stationCode
                    }, _toDisplayString(station.stationCode) + " : " + _toDisplayString(station.companyName), 9 /* TEXT, PROPS */, _hoisted_38))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.selectedStation]
                ])
              ]),
              _createElementVNode("span", _hoisted_39, _toDisplayString($setup.selectedStationerror), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            ($setup.buttonName == 'Add')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary add footer-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.AddMenuStationMapping()))
                }, _toDisplayString($setup.buttonName), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.buttonName == 'Update')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary footer-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.EditMenuStationMapping()))
                }, _toDisplayString($setup.buttonName), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary footer-btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.DeleteMenuStationMapping()))
            }, " Delete ")
          ])
        ])
      ])
    ])
  ]))
}